import {
  CMS_ROUTES,
  MUST_SET_PASSWORD_KEY,
  TOKEN_KEY,
} from "../../Frontend/Constant";

/** Public / transitional routes — finish login first; do not block these. */
export const HIDE_SET_PASSWORD_ON_PATHS = new Set([
  ...CMS_ROUTES,
  "/whitelist-login",
]);

/**
 * Whether the forced set-password modal should be open.
 * Never clears MUST_SET_PASSWORD_KEY — only a successful set-password does.
 */
export function shouldShowSetPasswordModal(pathname) {
  const flag = localStorage.getItem(MUST_SET_PASSWORD_KEY) === "true";
  const token = localStorage.getItem(TOKEN_KEY);
  const path = pathname?.split("?")[0] || "/";

  if (!flag || !token) return false;
  if (HIDE_SET_PASSWORD_ON_PATHS.has(path)) return false;
  return true;
}
